/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DueDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function DueDate({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim/DueDate",
  onChange
  
}) {
let createClaimDueDateValueData = fromData.useDataFormat({ viewPath,
context: 'create_claim',
path: 'due_date',
format: fromFormat.dateISOIn,
})
let createClaimDueDateChangeData = fromData.useDataChange({ viewPath,
context: 'create_claim',
path: 'due_date',
formatOut: fromHelpers.formatOutDate,
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 maxWidth={200}
 type="text"
 position="relative"
 data="create_claim.due_date"
 format="/Data/format.js dateISOIn"
 formatOut="helpers.js formatOutDate"
 value={createClaimDueDateValueData}
 onChange={createClaimDueDateChangeData}
 autoFocus={false}
 required={true}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Due date"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}